import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { CoreOrderAudit } from "../model/core/CoreOrderAudit";

export const CHANNEL_AUDIT_SERVICE: string = "OrderAuditServiceChannel";

export interface IOrderAuditService {
  getOrderAudit(orderId: string, protocol: string): Promise<Array<CoreOrderAudit>>;
}
